import React, { createContext, useContext, useState, useEffect } from 'react';

// Fully separate from AuthContext (staff auth) — different cookie
// (creator_token vs token), different endpoints, different principal shape.
// Must never be merged with AuthContext so the two session worlds can't
// cross-contaminate on the shared creators.socialinfinite.com origin.
const CreatorAuthContext = createContext(null);

export function CreatorAuthProvider({ children }) {
  const [creator, setCreator] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetch('/api/creator-auth/me', { credentials: 'include' })
      .then(r => r.json())
      .then(d => { if (d.success) setCreator(d.creator); })
      .catch(() => {})
      .finally(() => setLoading(false));
  }, []);

  async function requestOtp(email) {
    const res = await fetch('/api/creator-auth/request-otp', {
      method: 'POST', credentials: 'include',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ email }),
    });
    const data = await res.json();
    if (!res.ok) return { success: false, error: data.error || 'Something went wrong.' };
    return { success: true };
  }

  async function verifyOtp(email, code) {
    const res = await fetch('/api/creator-auth/verify-otp', {
      method: 'POST', credentials: 'include',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ email, code }),
    });
    const data = await res.json();
    if (!res.ok) return { success: false, error: data.error || 'Invalid or expired code.' };
    setCreator(data.creator);
    return { success: true };
  }


  async function logout() {
    await fetch('/api/creator-auth/logout', { method: 'POST', credentials: 'include' });
    setCreator(null);
  }

  return (
    <CreatorAuthContext.Provider value={{ creator, loading, requestOtp, verifyOtp, logout }}>
      {children}
    </CreatorAuthContext.Provider>
  );
}

export function useCreatorAuth() {
  return useContext(CreatorAuthContext);
}
